import { StructuredText, renderNodeRule } from 'react-datocms'

import { Box, Text } from '@factorialco/deprecated-design-system'
import {
  isBlockquote,
  isHeading,
  isList,
  isListItem,
  isParagraph,
} from 'datocms-structured-text-utils'

import * as styles from './index.vanilla.css'

type StructuredTextType = {
  id: string | number
  data: string
}

type ImageRecord = {
  alt: string
  url: string
}

type VideoRecord = {
  mimeType: string
  url: string
}

export const SetupInformation = ({ data, id }: StructuredTextType) => {
  return (
    <Box paddingTop="s64" width="narrowPage" paddingX="s4">
      <div className={styles.formattedText}>
        <StructuredText
          data={JSON.parse(data)}
          key={id}
          renderBlock={({ record }) => {
            switch (record.__typename) {
              case 'MediaImageRecord':
                // eslint-disable-next-line no-type-assertion/no-type-assertion
                const image = record.image as ImageRecord
                return (
                  <Box paddingY="s24">
                    <img alt={image.alt} src={image.url} className={styles.image} />
                  </Box>
                )
              case 'MediaVideoRecord':
                // eslint-disable-next-line no-type-assertion/no-type-assertion
                const video = record.video as VideoRecord
                return (
                  <Box paddingY="s24">
                    <video controls className={styles.video}>
                      <source src={video.url} type={video.mimeType} />
                    </video>
                  </Box>
                )
              default:
                return null
            }
          }}
          customNodeRules={[
            renderNodeRule(isHeading, ({ key, children }) => {
              return (
                <div className={styles.heading} role="heading" key={key}>
                  <Text.Header1>{children}</Text.Header1>
                </div>
              )
            }),
            renderNodeRule(isBlockquote, ({ key, children }) => {
              return (
                <p className={styles.blockquote} key={key}>
                  {children}
                </p>
              )
            }),
            renderNodeRule(isList, ({ key, children, node }) => {
              return node.style === 'bulleted' ? (
                <ul className={styles.unorderedList} key={key}>
                  {children}
                </ul>
              ) : (
                <ol className={styles.list} key={key}>
                  {children}
                </ol>
              )
            }),
            renderNodeRule(isListItem, ({ key, children }) => {
              return (
                <li className={styles.listItem} key={key}>
                  {children}
                </li>
              )
            }),
            renderNodeRule(isParagraph, ({ key, children }) => {
              return <Text.Normal key={key}>{children}</Text.Normal>
            }),
          ]}
        />
      </div>
    </Box>
  )
}
